import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, ErrorState, SheetHeader } from '@/ui';
export function SheetFrame({title,onClose,children,actions,className='',dismissal='close'}:{title:string;onClose:()=>void;children:ReactNode;actions?:ReactNode;className?:string;dismissal?:'close'|'cancel'}) {
 const {t}=useTranslation('common'),cancellation=dismissal==='cancel';
 return <section className={`chat-sheet ${className}`}>
  <SheetHeader className="chat-sheet-header" title={title} largeTitle={cancellation}
   leading={cancellation?<Button variant="plain" onClick={onClose}>{t('cancel')}</Button>:undefined}
   trailing={<>{actions}{!cancellation&&<IconButton name="xmark" label={t('close')} onClick={onClose}/>}</>}/>
  <div className="chat-sheet-content">{children}</div>
 </section>;
}
export function SheetError({message,onRetry}:{message?:string;onRetry?:()=>void}) {const {t}=useTranslation('chat');return <ErrorState title={message??t('state.connectionHint')} action={onRetry?<Button variant="tinted" onClick={onRetry}>{t('common:retry')}</Button>:undefined}/>;}
